import { HTTPClient } from '@abaco/web-common/src/HTTP';
import axios, { CancelTokenSource } from "axios";
import { PagedResults, PagingParams } from '@abaco/web-common/src/Paging';
import { Team, TeamOut, TeamRole, TeamSubject, TeamSubjectOut, TeamSubjectUpdateOut, Subject } from '../models/Team';
import { UnitOfMeasure } from '../models/UnitsOfMeasure';
import { Equipment, Implant } from '../models/Equipment';

export default class TeamApi {

    private http: HTTPClient;
    private rootPath: string;
    private cancelTokenSource: CancelTokenSource | null;

    constructor(http: HTTPClient, rootPath: string) {
        this.http = http;
        this.rootPath = rootPath;
        this.cancelTokenSource = null;
    }

    public async getTeams(pkCuaa: number, paging: PagingParams, filter: string | null): Promise<PagedResults<Team>>{
        const filterArr = [];
        if (filter) {
            filterArr.push(`^description like ${filter.toUpperCase()}`);
        }
        const res = await this.http.get(`${this.rootPath}/v1/teams/related_to/${pkCuaa}/teams`, {
            params: {
                offset: paging.offset,
                count: paging.count,
                filter: filterArr.length > 0 ? filterArr : undefined,
            }
        });
        return res.data;
        // const els: Team[] = [];
        // for (let i = 1; i < 4; i++) {
        //     const el: Team = {
        //         fl_dataset_visibility: i,
        //         owner_subject_id: i,
        //         relation_type_id: i,
        //         role_type_code: "a "+i,
        //         default_form_id: i,
        //         last_update_date: i,
        //         owner_fiscal_code: "a "+i,
        //         owner_vat_number: "a "+i,
        //         owner_full_name: "a "+i,
        //         owner_last_name: "a "+i,
        //         owner_company_code: "a "+i,
        //         role_type_id: i,
        //         subject_id: i,
        //         start_date: i,
        //         end_date: i,
        //         role_type_desc: "squadra per la raccolta "+i,
        //         pkid: i,
        //         fl_valid: i,
        //         fl_active: i,
        //         fl_sys: i,
        //         owner_name: "a "+i,
        //         relation_id: i,
        //     };
        //     els.push(el);
        // }
        // const page: PagedResults<Team> = {
        //     totalcount: 4,
        //     offset: 0,
        //     records: els,
        //     count: 4,
        // }
        // return page;
    }
    public async getTeamRoles(teamId: number, paging: PagingParams, filter: string | null): Promise<PagedResults<TeamRole>>{
        const filterArr = [];
        if (filter) {
            filterArr.push(`^description like ${filter.toUpperCase()}`);
        }
        const res = await this.http.get(`${this.rootPath}/v1/teams/${teamId}/roles`, {
            params: {
                offset: paging.offset,
                count: paging.count,
                filter: filterArr.length > 0 ? filterArr : undefined,
            }
        })
        return res.data;
    }
    public async getTeamRoleSubjects(teamId: number, roleId: number, paging: PagingParams, filter: string | null): Promise<PagedResults<TeamSubject>>{
        const filterArr = [];
        if (filter) {
            filterArr.push(`^description like ${filter.toUpperCase()}`);
        }
        const res = await this.http.get(`${this.rootPath}/v1/teams/${teamId}/roles/${roleId}/subjects`, {
            params: {
                offset: paging.offset,
                count: paging.count,
                filter: filterArr.length > 0 ? filterArr : undefined,
            }
        })

        return res.data;
    }
    public async getTeamSubjects(teamId: number, paging: PagingParams, filter: string | null): Promise<PagedResults<TeamSubject>>{
        const filterArr = [];
        if (filter) {
            filterArr.push(`^description like ${filter.toUpperCase()}`);
        }
        const res = await this.http.get(`${this.rootPath}/v1/teams/${teamId}/involved`, {
            params: {
                offset: paging.offset,
                count: paging.count,
                filter: filterArr.length > 0 ? filterArr : undefined,
            }
        })
        return res.data;
        // const els: TeamSubject[] = [];
        // for (let i = 1; i < 4; i++) {
        //     const el: TeamSubject = {
        //         fl_dataset_visibility: i,
        //         relation_type_id: i,
        //         role_type_code: "a"+i,
        //         default_form_id: i,
        //         role_type_id: i,
        //         subject_id: i,
        //         company_code: "a"+i,
        //         start_date: new Date(),
        //         end_date: new Date(),
        //         subject_fiscal_code: "a"+i,
        //         subject_vat_number: "a"+i,
        //         subject_full_name: "a"+i,
        //         subject_last_name: "a"+i,
        //         role_type_desc: "a"+i,
        //         last_update: i,
        //         subject_name: "a"+i,
        //         pkid: i,
        //         fl_valid: i,
        //         fl_active: i,
        //         fl_sys: i,
        //         relation_id: i,
        //     };
        //     els.push(el);
        // }
        // const page: PagedResults<TeamSubject> = {
        //     totalcount: 4,
        //     offset: 0,
        //     records: els,
        //     count: 4,
        // }
        // return page;
    }

    public async insertTeam(pkCuaa: number, detailOut: TeamOut): Promise<Team> {
        const res = await this.http.post(`${this.rootPath}/v1/teams/related_to/${pkCuaa}/teams`, detailOut);
        return res.data;
    }
    public async editTeam(pkCuaa: number, teamId: number, detailOut: TeamOut): Promise<Team> {
        const res = await this.http.put(`${this.rootPath}/v1/teams/related_to/${pkCuaa}/teams/${teamId}`, detailOut);
        return res.data;
    }
    public async deleteTeam(pkCuaa: number, teamId: number): Promise<Team> {
        const res = await this.http.delete(`${this.rootPath}/v1/teams/related_to/${pkCuaa}/teams/${teamId}`);
        return res.data;
    }

    public async insertTeamSubject(pkCuaa: number, teamId: number, detailOut: TeamSubjectOut): Promise<TeamSubject> {
        const res = await this.http.post(`${this.rootPath}/v1/teams/related_to/${pkCuaa}/teams/${teamId}/involved`, detailOut);
        return res.data;
    }
    public async editTeamSubject(teamId: number, pkid: number, detailOut: TeamSubjectUpdateOut): Promise<TeamSubject> {
        const res = await this.http.put(`${this.rootPath}/v1/teams/${teamId}/involved/${pkid}`, detailOut);
        return res.data;
    }
    public async deleteTeamSubject(teamId: number, pkid: number): Promise<TeamSubject> {
        const res = await this.http.delete(`${this.rootPath}/v1/teams/${teamId}/involved/${pkid}`);
        return res.data;
    }

    public async getSubjects(paging: PagingParams, filter: string | null, searchBy?: string): Promise<PagedResults<Subject>> {
        const res = await this.http.get(`${this.rootPath}/v1/people_registry/subjects`, {
            params: {
                offset: paging.offset,
                count: paging.count,
                filter: filter ? `^full_name like ${filter.toUpperCase()}` : undefined
            }
        })
        return res.data;
    }

    public async getWorkers(pkCuaa: number, paging: PagingParams, filter: string | null, searchBy?: string): Promise<PagedResults<Subject>> {
        const res = await this.http.get(`${this.rootPath}/v1/workers/${pkCuaa}/involved_no_roles`, {
            params: {
                offset: paging.offset,
                count: paging.count,
                filter: filter ? `^subject_full_name like ${filter.toUpperCase()}` : undefined
            }
        })
        return res.data;
    }

}
